import React, { useState, useRef } from "react";
import featureBg from "../../images/bg/features-gradient-bg.png";
import diamondIcon from "../../images/icon/diamond-icon02.gif";
import feaIcon01 from "../../images/icon/fea-small-icon01.svg";
import feaIcon02 from "../../images/icon/fea-small-icon02.svg";
import feaIcon03 from "../../images/icon/fea-small-icon03.svg";
import feaIcon04 from "../../images/icon/fea-small-icon04.svg";
import feaIcon05 from "../../images/icon/fea-small-icon05.svg";
import feaIcon06 from "../../images/icon/fea-small-icon06.svg";
import botVideo from "../../images/video/Yecho-Vid.mp4";
import centrlizedknowledge from "../../images/icon/Centralized_Knowledge.svg"
import enterpriseIntegrations from "../../images/icon/Enterprise_Integrations.svg"
import increasedProductivity from "../../images/icon/Increased_Productivity.svg"
import AlwaysAvailable from "../../images/icon/Always_Available.svg"
import RAGBotRedefined from "../../images/icon/RAG_Bot_Redefined.svg"

const FeaturesAndBrands: React.FC = () => {
  const [modalVideoUrl, setModalVideoUrl] = useState<string | null>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const openVideo = (url: string) => {
    setModalVideoUrl(url);
    setTimeout(() => {
      if (iframeRef.current) iframeRef.current.src = url;
    }, 50);
  };

  const closeVideo = () => {
    if (iframeRef.current) iframeRef.current.src = "about:blank";
    setModalVideoUrl(null);
  };

  return (
    <div
      className="bg_img"
      style={{
        background: `url(${featureBg}) no-repeat center center`,
        backgroundSize: "cover",
      }}
    >
      {/* Feature Section */}
      <section className="feature pt-145 pb-145">
        <div className="container">
          <div className="sec-title sec-title-center fea-sec-title text-center mb-50">
            <h2 className="title">
              Why organizations
              choose Yecho {" "}
              <span>
                <img src={diamondIcon} alt="icon" />
              </span>{" "}
            </h2>
            {/* <h2 className="title">
              Your success{" "}
              <span>
                <img src={diamondIcon} alt="icon" />
              </span>{" "}
              is our mission
            </h2> */}
          </div>

          <div className="row mt-none-30 align-items-center xb-feature-layout">
            {/* Left Features */}
            <div className="col-lg-4 col-md-6 mt-30 xb-feature-col-left">
              <div className="xb-feature-left-item">
                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay="100ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/OUB6zKc-Tos?autoplay=1")}
                >
                  <div className="xb-item--inner justify-content-center xb-border">
                    <h2 className="xb-item--title text-end" style={{ flexGrow: 1, minWidth: 0 }}>
                      Centralized knowledge
                    </h2>
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={centrlizedknowledge} alt="icon" />
                    </span>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/2ePf9rue1Ao?autoplay=1")}
                >
                  <div className="xb-item--inner justify-content-end xb-border">
                    <h2 className="xb-item--title text-end" style={{ flexGrow: 1, minWidth: 0 }}>
                      Enterprise integrations
                    </h2>
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={enterpriseIntegrations} alt="icon" />
                    </span>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay="300ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/H155s26S8v0?autoplay=1")}
                >
                  <div className="xb-item--inner justify-content-end xb-border">
                    <h2 className="xb-item--title text-end" style={{ flexGrow: 1, minWidth: 0 }}>
                      Increased productivity
                    </h2>
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={increasedProductivity} alt="icon" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Features */}
            <div className="col-lg-4 col-md-6 order-lg-last mt-30 xb-feature-col-right">
              <div className="xb-feature-right-item">

                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/5q87K1W6-g8?autoplay=1")}
                >
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={RAGBotRedefined} alt="icon" />
                    </span>
                    <h2 className="xb-item--title" style={{ flexGrow: 1, minWidth: 0 }}>
                      RAG bot redefined
                    </h2>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay="100ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/tr7C3T5d4n0?autoplay=1")}
                >
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={feaIcon04} alt="icon" />
                    </span>
                    <h2 className="xb-item--title" style={{ flexGrow: 1, minWidth: 0 }}>
                      Secure by design
                    </h2>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay="300ms"
                  data-wow-duration="600ms"
                  style={{ cursor: "pointer" }}
                // onClick={() => openVideo("https://www.youtube.com/embed/mJeNghnyt9s?autoplay=1")}
                >
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--icon" style={{ flexShrink: 0 }}>
                      <img src={feaIcon06} alt="icon" />
                    </span>
                    <h2 className="xb-item--title" style={{ flexGrow: 1, minWidth: 0 }}>
                      Smart Request Routing
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Center Video */}
            <div className="col-lg-4 col-md-12 mt-30 xb-feature-col-center">
              <div
                className="xb-feature-img pos-rel text-center wow zoomIn"
                data-wow-delay="0ms"
                data-wow-duration="600ms"
              >
                <video
                  className="xb-feature-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                  aria-label="Yecho AI assistant demo"
                >
                  <source src={botVideo} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <BrandSection/> */}

      {modalVideoUrl && (
        <div
          role="dialog"
          aria-modal="true"
          className="video-popup-overlay"
          onClick={closeVideo}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="video-popup"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "min(900px, 90vw)",
              aspectRatio: "16 / 9",
              background: "#000",
              borderRadius: 12,
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            <iframe
              ref={iframeRef}
              title="Feature Video"
              width="100%"
              height="100%"
              src="about:blank"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              frameBorder={0}
            />
            <button
              onClick={closeVideo}
              aria-label="Close video"
              style={{
                position: "absolute",
                top: 10,
                right: 14,
                color: "#fff",
                background: "transparent",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeaturesAndBrands;